import { useTranslation } from '../../../../../shared/i18n';
import React from 'react';
import { Select, Checkbox, Tooltip } from 'antd';
import { PRICE_RANGES } from './searchUtils';

/**
 * 紧凑筛选条：分类 / 价格 / 支持的语言 / 仅 IDN 后缀
 * filters = { category, price, language, idnOnly }
 */
const FilterBar = ({ catalog, filters, onChange, count, extra }) => {
    const { t } = useTranslation();
    const set = (patch) => onChange({ ...filters, ...patch });

    const categoryOptions = [
        { value: 'all', label: t('All TLDs') },
        ...Object.entries(catalog?.categories || {})
            .filter(([, c]) => (c.items || []).length > 0)
            .map(([k, c]) => ({ value: k, label: `${t(c.label)} · ${(c.items || []).length}` })),
    ];

    const languageOptions = Object.entries(catalog?.languages || {}).map(([k, l]) => ({
        value: k,
        label: `${t(l.label)} · ${l.count}`,
        search: `${l.label} ${l.label_en} ${k}`.toLowerCase(),
    }));

    return (
        <div className="ds-filters">
            <Select
                size="middle"
                value={filters.category || 'all'}
                onChange={(v) => set({ category: v })}
                options={categoryOptions}
                popupMatchSelectWidth={false}
                aria-label={t('Category')}
            />
            <Select
                value={filters.price || 'all'}
                onChange={(v) => set({ price: v })}
                options={PRICE_RANGES.map(({ value, label }) => ({ value, label: t(label) }))}
                aria-label={t('Price')}
            />
            <Select
                allowClear
                showSearch
                placeholder={t('Supported languages')}
                value={filters.language || undefined}
                onChange={(v) => set({ language: v || null })}
                options={languageOptions}
                filterOption={(input, opt) => opt.search.includes(input.toLowerCase())}
                popupMatchSelectWidth={false}
                style={{ minWidth: 150 }}
                aria-label={t('Supported languages')}
            />
            <Tooltip title={t('The suffix itself contains non-English characters, such as Chinese, e.g., .中国')}>
                <Checkbox checked={!!filters.idnOnly} onChange={(e) => set({ idnOnly: e.target.checked })}>
                    {t('Multilingual TLDs only')}
                </Checkbox>
            </Tooltip>
            {extra}
            {count != null && <span className="ds-filter-count">{t('{{count}} TLDs', { count })}</span>}
        </div>
    );
};

export default FilterBar;
